import React from 'react';
import cs from 'classnames';

export function Wave({ className }: { className?: string }) {
    const classNames = cs('absolute top-32 bottom-0 right-0 left-0 z-0', className);
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1440 640"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            className={classNames}
        >
            <path
                d="M473 15.9267C217.959 37.5808 116 31.8926 0 20.7249V640H1440V7.72198C1363 20.7249 915 -21.6011 473 15.9267Z"
                fill="#e8f6f8"
                fillOpacity="1"
            />
        </svg>
    );
}
